import React from 'react';

import {
    Row, Col, Container, Tabs, Tab,
} from 'react-bootstrap';

import { HTG_IMAGE } from '../util/constants';

const SampleProjectComponent = () => (
    <Container fluid className="gs-block">
        <Container>
            <h3 className="text-center pb-3">Past Years Winners</h3>
            <Tabs className="gs-tabs pt-2 pb-4" defaultActiveKey="0">
                {/* 2025 winners */}
                <Tab eventKey="0" title="2025">
                    <Row data-aos="fade-up">
                        <Col lg={3} data-aos="zoom-in" className="pb-md-5">
                            <div
                                className="gs-htg-hack-box mb-3"
                                style={{ backgroundImage: `linear-gradient(0deg, rgba(61, 61, 61, 0.5), rgba(61, 61, 61, 0.5)), url(${HTG_IMAGE.first2025})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
                            >
                                <div>
                                    <p><b>1st Place</b></p>
                                    <h4 className="pb-2">Medi</h4>
                                    <p>
                                        This refugee health platform provides portable, patient-owned medical records using AI to translate and extract information, blockchain for secure storage, and QR codes for easy sharing.
                                    </p>
                                    <p>
                                        Chanelle Cai, Justin Cheng, Jason Kuo, Hanna Shiohara
                                    </p>
                                </div>
                            </div>
                        </Col>
                        <Col lg={3} data-aos="zoom-in" className="pb-md-5">
                            <div
                                className="gs-htg-hack-box mb-3"
                                style={{ backgroundImage: `linear-gradient(0deg, rgba(61, 61, 61, 0.5), rgba(61, 61, 61, 0.5)), url(${HTG_IMAGE.second2025})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
                            >
                                <div>
                                    <p><b>2nd Place</b></p>
                                    <h4 className="pb-2">Echo Style</h4>
                                    <p>
                                        This responsible-consumption solution uses AI to simplify second-hand shopping, using AI swiping, image recognition, and a chatbot to make thrifting more convenient to shoppers.
                                    </p>
                                    <p>
                                        Amelie Gong, Madison Lee, Shuolin Yin, Jocelyn Young
                                    </p>
                                </div>
                            </div>
                        </Col>
                        <Col lg={3} data-aos="zoom-in" className="pb-md-5">
                            <div
                                className="gs-htg-hack-box mb-3"
                                style={{ backgroundImage: `linear-gradient(0deg, rgba(61, 61, 61, 0.5), rgba(61, 61, 61, 0.5)), url(${HTG_IMAGE.third2025})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
                            >
                                <div>
                                    <p><b>3rd Place</b></p>
                                    <h4 className="pb-2">Ethical Microloans</h4>
                                    <p>
                                        This microlending platform helps connect ethical investors with Indian micro-entrepreneurs by using a marketplace to reduce capital friction.
                                    </p>
                                    <p>
                                        Simileoluwa Adewale, Chinonso Anosike, Harishiga Ilangovan, Abhiraj Singh
                                    </p>
                                </div>
                            </div>
                        </Col>
                        <Col lg={3} data-aos="zoom-in" className="pb-md-5">
                            <div
                                className="gs-htg-hack-box pb-3"
                                style={{ backgroundImage: `linear-gradient(0deg, rgba(61, 61, 61, 0.5), rgba(61, 61, 61, 0.5)), url(${HTG_IMAGE.peoplechoice2025})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
                            >
                                <div>
                                    <p><b>People's Choice</b></p>
                                    <h4 className="pb-2">FairVio</h4>
                                    <p>
                                        This AI-powered platform helps migrant farm workers safely report labor abuses with multilingual legal support, pro-bono lawyers, and anonymized case escalation to overcome retaliation fears.
                                    </p>
                                    <p>
                                        Jaehyuk Choi, Minjun Kim, Jimin Lee, Cathy Zuo
                                    </p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Tab>

                {/* 2024 winners */}
                <Tab eventKey="1" title="2024">
                    <Row data-aos="fade-up">
                        <Col lg={4} data-aos="zoom-in" className="pb-md-5">
                            <div
                                className="gs-htg-hack-box mb-3"
                                style={{ backgroundImage: `linear-gradient(0deg, rgba(61, 61, 61, 0.5), rgba(61, 61, 61, 0.5)), url(${HTG_IMAGE.first2024})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
                            >
                                <div>
                                    <p><b>1st Place</b></p>
                                    <h4 className="pb-4">EcoTrack</h4>
                                    <p>
                                        This sustainable societies solution uses smart composters to turn waste into compost while monitoring waste disposal behaviour to fix the issue of presistent food waste.
                                    </p>
                                    <p>
                                        FantasticFour
                                    </p>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} data-aos="zoom-in" className="pb-md-5">
                            <div
                                className="gs-htg-hack-box mb-3"
                                style={{ backgroundImage: `linear-gradient(0deg, rgba(61, 61, 61, 0.5), rgba(61, 61, 61, 0.5)), url(${HTG_IMAGE.second2024})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
                            >
                                <div>
                                    <p><b>2nd Place</b></p>
                                    <h4 className="pb-4">Ecolizer</h4>
                                    <p>
                                        This economic empowerment solution automates nutrient calculations with IoT sensors and enables mobile accessible soil carbon scores to combat the land degradation estimate by 2025.
                                    </p>
                                    <p>
                                        Acyuta Jr, Kiana Cezar, Shraavasti Bhat, Vito Samudra
                                    </p>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} data-aos="zoom-in" className="pb-md-5">
                            <div
                                className="gs-htg-hack-box pb-3"
                                style={{ backgroundImage: `linear-gradient(0deg, rgba(61, 61, 61, 0.5), rgba(61, 61, 61, 0.5)), url(${HTG_IMAGE.third2024})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
                            >
                                <div>
                                    <p><b>3rd Place</b></p>
                                    <h4 className="pb-4">Empact</h4>
                                    <p>
                                        This economic empowerment solution aimed to increase teaching support among refugees by introducing an AI chatbot designed to support teachers in the Kakuma refugee camp.
                                    </p>
                                    <p>
                                        Daniel Eid, Tian Ahn Leow, Charlotte Scheideler, William Shaw
                                    </p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Tab>

                {/* 2023 winners */}
                <Tab eventKey="2" title="2023">
                    <Row data-aos="fade-up">
                        <Col lg={4} data-aos="zoom-in" className="pb-md-5">
                            <div
                                className="gs-htg-hack-box mb-3"
                                style={{ backgroundImage: `linear-gradient(0deg, rgba(61, 61, 61, 0.5), rgba(61, 61, 61, 0.5)), url(${HTG_IMAGE.first2023})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
                            >
                                <div>
                                    <p><b>1st Place</b></p>
                                    <h4 className="pb-4">BagSHARE</h4>
                                    <p>
                                        This sustainable societies solution aimed to transform the resuable bag industry, one bag at a time by allowing consumers to borrow bags using a client app.
                                    </p>
                                    <p>
                                        William Qian, Wendy Zhao, Shaba Khan, Gerry Chen
                                    </p>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} data-aos="zoom-in" className="pb-md-5">
                            <div
                                className="gs-htg-hack-box mb-3"
                                style={{ backgroundImage: `linear-gradient(0deg, rgba(61, 61, 61, 0.5), rgba(61, 61, 61, 0.5)), url(${HTG_IMAGE.second2023})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
                            >
                                <div>
                                    <p><b>2nd Place</b></p>
                                    <h4 className="pb-4">AdaptEd</h4>
                                    <p>
                                        This economic empowerment solution is an educational platform incorporating AI-powered tools to offer inclusive education for students with learning disabilities.
                                    </p>
                                    <p>
                                        Sydney Basil, Haven Townsend, Jenna Cockburn, Shubham Kumar, Saisha Batthula
                                    </p>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} data-aos="zoom-in" className="pb-md-5">
                            <div
                                className="gs-htg-hack-box pb-3"
                                style={{ backgroundImage: `linear-gradient(0deg, rgba(61, 61, 61, 0.5), rgba(61, 61, 61, 0.5)), url(${HTG_IMAGE.third2023})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
                            >
                                <div>
                                    <p><b>3rd Place</b></p>
                                    <h4 className="pb-4">CheckMate</h4>
                                    <p>
                                        This economic empowerment solution aimed to alleviate loneliness among the elderly by introducing an app equipped with a voice call feature and cognitive games.
                                    </p>
                                    <p>
                                        Dionysia Balafa, Jacopo Chirico, Begona Palenzuela Herrera, Szymon Podpora, Lile Zhang Zhuo
                                    </p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Tab>

                {/* 2021 winners */}
                <Tab eventKey="3" title="2021">
                    <Row data-aos="fade-up">
                        <Col lg={4} data-aos="zoom-in" className="pb-md-5">
                            <div
                                className="gs-htg-hack-box mb-3"
                                style={{ backgroundImage: `linear-gradient(0deg, rgba(61, 61, 61, 0.5), rgba(61, 61, 61, 0.5)), url(${HTG_IMAGE.winner2021})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
                            >
                                <div>
                                    <p><b>1st Place</b></p>
                                    <h4 className="pb-4">reuseableEats</h4>
                                    <p>
                                        This climate change solution aimed to reduce plastic waste generated from take-out orders through a reusable container-sharing subscription program for the restaurant industry.
                                    </p>
                                    <p>
                                        Catherine Tsang, Felicity Wang, Karan Vasdev, Stephanie Sha
                                    </p>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} data-aos="zoom-in" className="pb-md-5">
                            <div
                                className="gs-htg-hack-box mb-3"
                                style={{ backgroundImage: `linear-gradient(0deg, rgba(61, 61, 61, 0.5), rgba(61, 61, 61, 0.5)), url(${HTG_IMAGE.runnerup2021})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
                            >
                                <div>
                                    <p><b>Runner Up</b></p>
                                    <h4 className="pb-4">Argent</h4>
                                    <p>
                                        This economic empowerment solution utilized a SMS-based chat bot to provide agricultural loans &amp; financing solutions for rural farmers.
                                    </p>
                                    <p>
                                        Georgia Bryson, Hassan El-Essawi, Jason Amri, Sean Cornelius
                                    </p>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} data-aos="zoom-in" className="pb-md-5">
                            <div
                                className="gs-htg-hack-box pb-3"
                                style={{ backgroundImage: `linear-gradient(0deg, rgba(61, 61, 61, 0.5), rgba(61, 61, 61, 0.5)), url(${HTG_IMAGE.peoplechoice2021})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
                            >
                                <div>
                                    <p><b>People's Choice</b></p>
                                    <h4 className="pb-4">DermaSpect</h4>
                                    <p>
                                        This popular solution used image recognition AI to aid health care professionals diagnose patient skin health.
                                    </p>
                                    <p>
                                        Anunay Kumar, Ria Bhandari, Shreya Singh, Sidharth Jain
                                    </p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Tab>

                {/* 2020 winners */}
                <Tab eventKey="4" title="2020">
                    <Row data-aos="fade-up">
                        <Col lg={4} data-aos="zoom-in" className="pb-md-5">
                            <div
                                className="gs-htg-hack-box mb-3"
                                style={{ backgroundImage: `linear-gradient(0deg, rgba(61, 61, 61, 0.5), rgba(61, 61, 61, 0.5)), url(${HTG_IMAGE.winner})` }}
                            >
                                <div>
                                    <p><b>1st Place</b></p>
                                    <h4 className="pb-4">Connexus</h4>
                                    <p>
                                        This crisis response solution aimed to facilitate family reunification in crisis situations using image recognition technology.
                                    </p>
                                    <p>
                                        Hui Wen Zheng, Jai Aggarwal, Martina Facchin, Mia Nguyen
                                    </p>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} data-aos="zoom-in" className="pb-md-5">
                            <div
                                className="gs-htg-hack-box mb-3"
                                style={{ backgroundImage: `linear-gradient(0deg, rgba(61, 61, 61, 0.5), rgba(61, 61, 61, 0.5)), url(${HTG_IMAGE.runnerup})` }}
                            >
                                <div>
                                    <p><b>Runner Up</b></p>
                                    <h4 className="pb-4">HemoGo!</h4>
                                    <p>
                                        This global health solution aimed to ensure a steady supply of blood donations through encouragement and donor retention.
                                    </p>
                                    <p>
                                        Bayaan Shalaby, Henry Xu, Sarika Goel, Sheree Zhang
                                    </p>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} data-aos="zoom-in" className="pb-md-5">
                            <div
                                className="gs-htg-hack-box pb-3"
                                style={{ backgroundImage: `linear-gradient(0deg, rgba(61, 61, 61, 0.5), rgba(61, 61, 61, 0.5)), url(${HTG_IMAGE.peoplechoice})` }}
                            >
                                <div>
                                    <p><b>People’s Choice</b></p>
                                    <h4 className="pb-4">chickoo</h4>
                                    <p>
                                        This popular solution was an SMS platform that connected farmers in India to agricultural data specialized to their location and needs.
                                    </p>
                                    <p>
                                        Anna Wang, Chi-Hong Cheung, Jennifer Ge, Noah Simao
                                    </p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Tab>
            </Tabs>
        </Container>
    </Container>
);

export default SampleProjectComponent;
